<template>
  <div id="container">
    <div v-if="loading" class="loading">Loading...</div>

    <div v-if="error" class="error">{{ error }}</div>

    <div v-if="post" class="content">
        <p v-html="post.content"></p>
    </div>
  </div>
</template>
<style scoped>
#container {
  padding: 15px 70px 15px 70px;
}


@media only screen and (max-width: 1060px) {
  #content_container {
    margin: 0;
  }
}
</style>

<script>
export default {
  data() {
    return {
      loading: false,
      post: null,
      error: null,
      baseUrl: "",
    };
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
  },
  mounted() {
    this.getBaseUri();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData",
  },
  methods: {
    getBaseUri() {
      this.axios
        .get("/api/api.php?p=data/baseUrl")
        .then((response) => {
          this.baseUrl = response.data.sdata["url"];
          // console.log(this.baseUrl);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;

      // console.log(this.$route.params.id);
      // console.log(this.$route.params.type);

      // replace getPost with your data fetching util / API wrapper
      
      const urlParams = new URLSearchParams();
      urlParams.append("type", 3);
      this.axios({
        method: "post",
        url: "/api/api.php?p=app/imNote",
        data: urlParams,
      })
        .then((response) => {
          this.loading = false;
          this.post = response.data.sdata["data"];

          
        })
        .catch(function (error) {
          // 请求失败处理
          this.error = error.toString();
          console.log(error);
        });
    },
  },
};
</script>